<template>
  <div>
    <el-row class="cs-grey-bottom-border">
      <el-col>
        <span class="cs-homework-title">{{currentTermDesc}}在校报课</span>
      </el-col>
    </el-row>
    <el-row v-for="item in universityCourseList" :key="item.Id">
      <el-col>{{item.CourseName}}</el-col>
    </el-row>
    <div class="cs-courseHistory-item" v-for="item in speedupCourseList" :key="item.TermId">
      <el-row class="cs-grey-bottom-border">
        <el-col>
          <span class="cs-homework-title">{{item.Term}}速成报课</span>
        </el-col>
      </el-row>
      <el-row v-for="course in item.Courses" :key="course.Id">
        <el-col>{{course.CourseFullName}}</el-col>
      </el-row>
    </div>
    <div  class="cs-courseHistory-item" v-for="item in trainingCourseList" :key="item.TermId">
      <el-row class="cs-grey-bottom-border">
        <el-col>
          <span class="cs-homework-title">{{item.Term + " " + item.CategoryName}}速成报课</span>
        </el-col>
      </el-row>
      <el-row v-for="course in item.Courses" :key="course.Id">
        <el-col>{{course.CourseFullName}}</el-col>
      </el-row>
    </div>
    <el-row class="cs-grey-bottom-border cs-courseHistory-item">
      <el-col>
        <span class="cs-homework-title">{{currentCourse.CourseName}}课程信息</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col>老师:{{currentCourse.TeacherName}}</el-col>
    </el-row>
    <!-- <el-row>
      <el-col>
        所保成绩:{{currentCourse.EnsureScore}}
      </el-col>
    </el-row>-->
    <el-row>
      <el-col
        :class="{'cs-color-frenchgrey': currentCourse.Score == null || currentCourse.Score == ''}"
      >期末成绩:{{currentCourse.Score == null || currentCourse.Score == "" ? "未填写" : currentCourse.Score}}</el-col>
    </el-row>
  </div>
</template>

<style lang="scss">
.cs-courseHistory-item{
  margin-top: 20px;
}
</style>

<script>
import {
  getStudentCourseList,
  getStudentCourseupCourseRecords
} from "../../service/student.service";
import { getCurrentTerm } from "../../service/common.service.js";

export default {
  props: {
    data: {
      studentId: Number,
      courseId: Number,
      courseName: String
    }
  },
  data() {
    return {
      universityCourseList: [], //大学课程
      speedupCourseList: [], //速成大学课程
      trainingCourseList: [],
      englishTrainingCourseList: [],
      currentTermDesc: "",
      currentCourse: {},
      universityCourseListLoaded: false,
      speedupCourseListLoaded: false
    };
  },
  components: {},
  created() {
    getCurrentTerm().then(result => {
      if (!!result && result.success) {
        this.currentTermDesc = result.data.Description;
      }
    });
    this.init();
  },
  methods: {
    init() {
      this.universityCourseListLoaded = false;
      this.speedupCourseListLoaded = false;
      if (!!this.data && !!this.data.courseId && !!this.data.studentId) {
        getStudentCourseList(this.data.studentId)
          .then(result => {
            if (!!result && result.success) {
              this.universityCourseList = result.data;
            }
            this.universityCourseListLoaded = true;
            this.onDataLoaded();
          })
          .catch(() => {
            this.universityCourseListLoaded = true;
            this.onDataLoaded();
          });

        getStudentCourseupCourseRecords(this.data.studentId)
          .then(result => {
            if (!!result && result.success) {
              let list = result.data;

              this.speedupCourseList = list.filter(
                i => i.CourseType == 1 && i.IsCurrentTerm == true
              );
              this.trainingCourseList = list.filter(
                i => i.CourseType == 3 && i.IsCurrentTerm == true
              );
              
              this.getCurrentCourse(this.speedupCourseList);
              this.getCurrentCourse(this.trainingCourseList);
            }
            
            this.speedupCourseListLoaded = true;
            this.onDataLoaded();
          })
          .catch(() => {
            this.speedupCourseListLoaded = true;
            this.onDataLoaded();
          });
      }
    },
    getCurrentCourse(list){
      list.forEach(element => {
        element.Courses.forEach(course => {
          if (course.CourseId == this.data.courseId){
            this.currentCourse = course;
          }
        });
      });
    },
    onDataLoaded() {
      if (this.universityCourseListLoaded && this.speedupCourseListLoaded) {
        this.$emit("loaded");
      }
    }
  },
  watch: {
    data: function() {
      this.init();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/homework/studentCourseHistory.vue